import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectImageData, selectActiveComponent } from "../../_ducks/selector";
import { setLine, setMessage } from "../../_ducks/actions";

import { selectOptionsForDropdown, foundationTypes, storeysTypes } from "../../_ducks/utils";

import IDGenerator from "features/Model/Enclosure/Takeoff/TakeoffData/IDGenerator";

import Button from "components/Button";
import Input from "components/Input";
import Select from "components/Input/Select";

import { cancelButton, saveButton, inputMarginBottom, buttonRow, multiPointLineButtons } from "../style.module.scss";

const SetLine = ({
    imageData,
    cancel,
    onSet,
    image,
    activeComponent,
    foundation,
    storeys,
    deleteShape,
    setLine,
    setMessage,
}) => {
    const { lines = {} } = imageData[image] || {};
    const activeLine = lines[activeComponent] || {};

    const { id, foundationStorey = "", takeoffField = "" } = activeLine?.takeoff || {};

    const totalPoints = activeLine?.points?.length / 2;

    const foundationStoreySelectArr = [
        foundation.compType,
        ...storeysTypes.filter((storey) => Object.keys(storeys).includes(storey)),
    ];

    const foundationStoreySelect = foundationStoreySelectArr.map((val, index) => ({
        value: val.toLowerCase(),
        label:
            index === 0
                ? `Foundation - ${val.charAt(0).toUpperCase() + val.slice(1)}`
                : `${val.charAt(0).toUpperCase() + val.slice(1)}${
                      index === foundationStoreySelectArr.length - 1 ? "" : " Storey"
                  }`,
    }));

    const takeoffFieldOptions =
        selectOptionsForDropdown({
            shapeType: "line",
            foundation: foundationTypes.includes(foundationStorey) ? foundationStorey : "",
            storey: Object.keys(storeys).includes(foundationStorey) ? foundationStorey : "",
        }) || [];

    const withIdTakeoffFields = ["garage wall", "buffered wall perimeter"];

    const idGeneratorOption = {
        "garage wall": "gw",
        "buffered wall perimeter": "bf",
        // "wall height": "wh",
        // "floor header height": "fh",
    };

    return (
        <div>
            {!activeLine?.isSet ? (
                <>
                    <p>Click anywhere on the active page to place second line's point. A line must have 2 points.</p>
                    <div className={multiPointLineButtons}>
                        <Button smallPadding onClick={cancel} type="red" className={cancelButton}>
                            Cancel
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <div>
                        <Input
                            className={inputMarginBottom}
                            label={"Line's Name"}
                            input={{
                                value: activeLine.name,
                                onChange: (e) =>
                                    setLine(image, {
                                        ...activeLine,
                                        name: e,
                                        takeoff: {
                                            ...activeLine.takeoff,
                                            title: e,
                                        },
                                    }),
                            }}
                        />
                        <Select
                            className={inputMarginBottom}
                            label={"Select Foundation or Storey"}
                            options={foundationStoreySelect}
                            input={{
                                value: foundationStorey,
                                onChange: (e) =>
                                    setLine(image, {
                                        ...activeLine,
                                        takeoff: {
                                            ...activeLine.takeoff,
                                            foundationStorey: e,
                                            takeoffField: "",
                                        },
                                    }),
                            }}
                        />
                        <Select
                            label={"Select Takeoff Field"}
                            disabled={!foundationStorey}
                            options={takeoffFieldOptions?.map((val) => ({
                                value: val.toLowerCase(),
                                label: val,
                            }))}
                            input={{
                                value: takeoffField,
                                onChange: (e) => {
                                    const newId = withIdTakeoffFields.includes(e)
                                        ? !id || !id.includes(idGeneratorOption[e])
                                            ? IDGenerator(idGeneratorOption[e])
                                            : id
                                        : "";

                                    setLine(image, {
                                        ...activeLine,
                                        takeoff: {
                                            ...activeLine.takeoff,
                                            id: newId,
                                            takeoffField: e,
                                        },
                                    });
                                },
                            }}
                        />
                    </div>
                    <div className={`${buttonRow} `}>
                        <Button smallPadding onClick={deleteShape} type="red" className={cancelButton}>
                            Delete
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    imageData: selectImageData,
    activeComponent: selectActiveComponent,
});

const mapDispatchToProps = (dispatch) => ({
    setLine: (image, line) => dispatch(setLine(image, line)),
    setMessage: ({ message, type, anchorOrigin, autoHideDuration, isOpen, direction }) =>
        dispatch(
            setMessage({
                message,
                type,
                anchorOrigin,
                autoHideDuration,
                isOpen,
                direction,
            })
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetLine);
